import { useSWRConfig } from "swr";
import { useUserService } from "../services";
import { useTokenRefreshHandler } from "../hooks";
import { useActingAsOverrideHeader } from "../auth";
import { getUserToken } from "src/utils/jwtToken";
import { errorHandler } from "src/hooks/errorHandler";

interface SyncContactsResponse {
  totalSynced: number;
}

export function useSyncContacts() {
  const accessToken = getUserToken();
  const { mutate, cache } = useSWRConfig();

  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return (accountIds: number[]): Promise<SyncContactsResponse> =>
    service
      .post(`/api/contact/sync`)
      .set(headers)
      .send({ accountIds: accountIds })
      .then(tokenRefreshHandler)
      .then((res: Response) => {
        // @ts-ignore
        const keys = cache.keys();

        // Invalidate contact queries and force refresh.
        Array.from(keys)
          .filter((r: any) => r.includes("/api/contact"))
          .forEach((k: any) => {
            mutate(k);
          });

        return res;
      })
      .then((res: Response) => res.body)
      .catch(errorHandler);
}
